'use strict';

/** @type {import('./syntax')} */
module.exports = SyntaxError;



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-errors/syntax.js
// module id = 160
// module chunks = 0 15 16 17 18